import React from 'react'
import { Redirect } from 'react-router-dom'
import Footer from 'components/layout/Footer/index'
import NewHeader from 'components/layout/NewHeader/index'
import RightSidebar from 'components/RightSidebar/index'
import useGameMaintenanceCheck from 'hooks/useGameMaintenanceCheck'

const PrivateRoute = ({ Component, isAuthenticated, child, isHeader, isFooter, gameId, showSidebar = true }) => {
  useGameMaintenanceCheck(gameId)

  return isAuthenticated
    ? (
      <>
        {isHeader ? <NewHeader /> : <></>}
        <Component child={child} />
        {showSidebar && <RightSidebar />}
        {isFooter ? <Footer /> : <></>}
      </>
    )
    : (
      <Redirect to={{ pathname: '/' }} />
    )
}

export default PrivateRoute
